import React, { useState, useEffect } from "react";
import { Grid, Box, Typography } from "@mui/material";
import SideBar from "../../components/Sidebar/index";
import { Card, Breadcrumb, Form, Input, Select, Button } from "antd";
import { queenApiCalling } from "../../constant/API";
import { HomeOutlined, UserOutlined } from "@ant-design/icons";
import { ToastContainer, toast } from "react-toastify";
import { SyncLoader } from "react-spinners";
import "../../css/main.css";

export default function Index() {
  const formRef = React.useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();

  const onFinish = (v) => {
    setIsLoading(true);
    const params = {
      app_version: v.app_version,
      android: v.android,
      ios: v.ios,
      action: "UPDATE_APP_VERSION",
    };
    queenApiCalling(params).then((res) => {
      setIsLoading(false);
      if (res.status === "success") {
        toast.success(res.message);
      } else {
        toast.error(res.message);
      }
    });
  };

  const getServiceCharge = () => {
    let params = { action: "GET_APP_VERSION" };
    queenApiCalling(params).then((res) => {
      if (res.status === "success") {
        form.setFieldsValue({
          app_version: res.version,
          android: res.android,
          ios: res.ios,
        });
      }
    });
  };

  useEffect(() => {
    getServiceCharge();
  }, []);

  return (
    <Box>
      <Grid>
        <></>
      </Grid>
      <Box md={{ width: "100%" }} style={{ marginTop: "0px" }}>
        <Grid
          container
          rowSpacing={1}
          columnSpacing={{ xs: 1, sm: 1, md: 1 }}
          sx={{ flexDirection: { xs: "column", md: "row" } }}
        >
          <Grid item md={2}>
            <SideBar type={localStorage.getItem("adminSession").role} />
          </Grid>
          <Grid
            md={10}
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 1, md: 1 }}
            sx={{ flexDirection: { xs: "column", md: "row" } }}
            style={{ marginTop: "0px" }}
          >
            <Card
              title="Update App Version"
              style={{
                width: "98%",
                marginLeft: "1%",
                marginTop: "30px",
              }}
              extra={
                <Breadcrumb
                  items={[
                    {
                      href: "/dashboard",
                      title: <HomeOutlined />,
                    },

                    {
                      title: "App Version",
                    },
                  ]}
                />
              }
            >
              <Card style={{ width: "50%" }}>
                <Form
                  ref={formRef}
                  form={form}
                  layout="vertical"
                  name={"complex-form"}
                  labelCol={{
                    span: 8,
                  }}
                  wrapperCol={{
                    span: 24,
                  }}
                  style={{ width: "100%" }}
                  onFinish={onFinish}
                  autoComplete="off"
                  initialValues={{
                    remember: true,
                  }}
                >
                  <Form.Item
                    name="app_version"
                    label="App Version"
                    rules={[
                      {
                        required: true,
                        message: "Please enter app version",
                      },
                    ]}
                  >
                    <Input placeholder={"App Version"} />
                  </Form.Item>
                  <Form.Item
                    name="android"
                    label="Android App Link"
                    rules={[
                      {
                        required: true,
                        message: "Please enter android app link",
                      },
                    ]}
                  >
                    <Input placeholder={"Android Link"} />
                  </Form.Item>
                  <Form.Item
                    name="ios"
                    label="Ios App Link"
                    rules={[
                      {
                        required: true,
                        message: "Please enter ios app link",
                      },
                    ]}
                  >
                    <Input placeholder={"Ios App Link"} />
                  </Form.Item>

                  <Form.Item>
                    {isLoading ? (
                      <SyncLoader
                        color={"008080"}
                        loading={isLoading}
                        size={15}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                      />
                    ) : (
                      <Button
                        type="primary"
                        htmlType="submit"
                        style={{ background: "#fbc531", width: "100%" }}
                      >
                        Update App Version
                      </Button>
                    )}
                  </Form.Item>
                </Form>
              </Card>
            </Card>
          </Grid>
        </Grid>
      </Box>
      <ToastContainer />
    </Box>
  );
}
